import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetStoreClassesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStoreClassesQuery = { __typename?: 'Query', storeClasses?: { __typename?: 'StoreClassStateData', storeClasses: Array<{ __typename?: 'StoreClassEntryStateData', class: string, rank: number }> } | null };


export const GetStoreClassesDocument = new TypedDocumentString(`
    query GetStoreClasses {
  storeClasses {
    storeClasses {
      class
      rank
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetStoreClasses: build.query<GetStoreClassesQuery, GetStoreClassesQueryVariables | void>({
      query: (variables) => ({ document: GetStoreClassesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetStoreClassesQuery, useLazyGetStoreClassesQuery } = injectedRtkApi;
